import React, { Component } from "react";
import styles from "./reportTable.module.scss";
import { v4 as uuidv4 } from "uuid";
import Scrollbars from "react-custom-scrollbars-2";

class ReportTableHeader extends Component {
  getHedeaderItem(item, index) {
    return (
      <div
        key={uuidv4()}
        className={styles.reportTableHeaderItem}
        style={{
          width: item.width + "px",
        }}
      >
        {item.title} {item.measure !== null ? `(${item.measure}.)` : null}
      </div>
    );
  }

  render() {
    const { header, withScroll = true } = this.props;

    if (!withScroll) {
      return (
        <div className={styles.reportTableHeaderContainer}>
          {header.map((item, index) => {
            return this.getHedeaderItem(item, index);
          })}
        </div>
      );
    }

    return (
      <Scrollbars style={{ height: 120 + "px" }} autoHide={false} ref="scrollbarHeader">
        <div className={styles.reportTableHeaderContainer}>
          {header.map((item, index) => {
            return this.getHedeaderItem(item, index);
          })}
        </div>
      </Scrollbars>
    );
  }
}

export default ReportTableHeader;
